<template>
  <div class="add-items">
    <div :class="`add-items-box ${active ? 'active' : ''}`" @click="onClick()">
      <span :class="['round', disabled ? 'disabled' : '']"
        ><i class="fa fa-plus"></i
      ></span>
      <span class="text">{{ item.name || title }}</span>
      <span v-if="item.name" class="text">{{ title2 }}</span>
    </div>
    <div v-if="isplayer" class="invalid-error" v-show="error">
      {{ $lang("TEXT_AGE_CHILDREN").split("%br%")[0]
      }}{{
        $store.getters["base/getChildBirthday"]
          ? $store.getters["base/getChildBirthday"].from
          : ""
      }}{{ $lang("TEXT_AGE_CHILDREN").split("%br%")[1]
      }}{{
        $store.getters["base/getChildBirthday"]
          ? $store.getters["base/getChildBirthday"].to
          : ""
      }}
    </div>
    <div v-if="ismember" class="invalid-error" v-show="memberError">
      {{ $lang("10026")}}
    </div>
  </div>
</template>

<script>
import { $apis } from "@/helper";
export default {
  props: {
    index: Number,
    isplayer: {
      type: Boolean,
      default: false,
    },
    ismember: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default() {
        return {
          idNumber: "",
          name: null,
          isAdult: true,
          bornAt: null,
          isMan: false,
          gender:null,
        };
      },
    },
  },
  data() {
    return {
      from: "",
      to: "",
    };
  },
  created() {},
  methods: {
    onClick() {
      this.$emit("click");
    },
    getChildBirth() {
      $apis.family.ss().then((res) => {
        this.from = res.data.from;
        this.to = res.data.to;
      });
    },
  },
  computed: {
    active() {
      return this.item.name;
    },
    title() {
      return this.index == 0
        ? this.$lang("選取參賽兒童")
        : this.$lang("選取參賽家庭成員");
    },
    title2() {
      return this.index == 0 ? this.$lang("參賽兒童") : this.$lang("家庭成員");
    },
    memberError() {
      let bornAt = this.item.bornAt;
      if (!bornAt) return false;
      else {
        let year = new Date(bornAt).getFullYear();
        let from = new Date(
          this.$store.getters["base/getChildBirthday"]
            ? this.$store.getters["base/getChildBirthday"].from
            : ""
        ).getFullYear();
        let to = new Date(
          this.$store.getters["base/getChildBirthday"]
            ? this.$store.getters["base/getChildBirthday"].to
            : ""
        ).getFullYear();
        if (year < from ) {
          return false;
        } else {
          return true;
        }
      }
    },
    error() {
      let bornAt = this.item.bornAt;
      if (!bornAt) return false;
      else {
        let year = new Date(bornAt).getFullYear();
        let from = new Date(
          this.$store.getters["base/getChildBirthday"]
            ? this.$store.getters["base/getChildBirthday"].from
            : ""
        ).getFullYear();
        let to = new Date(
          this.$store.getters["base/getChildBirthday"]
            ? this.$store.getters["base/getChildBirthday"].to
            : ""
        ).getFullYear();
        if (year >= from && year <= to) {
          return false;
        } else {
          return true;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.round {
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  background: #b4b2b0;
  border: none !important;
}

.items-selete {
  max-width: 200px;
}

.text {
  font-size: 18px;
  font-weight: bold;
}

.add-items {
  margin: 20px 0;

  .invalid-error {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
  }

  .add-items-box {
    cursor: pointer;
    display: flex;
    opacity: 0.6;

    .text {
      margin: 0 10px;
      align-self: center;
    }

    &.active {
      opacity: 1;

      .round {
        background: #f89e1b !important;
      }

      .disabled {
        background: #eee !important;
      }
    }
  }
}
</style>
